import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'src/app/viewer/services/alert.service';
import { APIHelper } from '../../../../../../../shared/services/api-helper/api-helper.service';
import { UserService } from '../../../../../../../shared/services/user/user.service';
import {
  Notification,
  NotificationAuthority,
  NotificationAuthorityType
} from '../../../../../../notifications/interfaces/notification-base.interface';
import { AlertsNotificationsService } from '../../../../../../notifications/services/alerts-notifications.service';

import { DialogSelectUserComponent } from '../dialog-select-user/dialog-select-user.component';

@Component({
  selector: 'app-dialog-add-alert',
  templateUrl: './dialog-add-alert.component.html',
  styleUrls: ['./dialog-add-alert.component.scss']
})
export class DialogAddAlertComponent implements OnInit {
  public selectedId: string;
  public ariane;
  public loading: boolean;
  public file: any;
  public name: FormControl;
  public description: string;
  public date;
  public users: any[];
  public listuser: any[];
  public userids: string[] = [];
  public inheritedPermissions: any[];
  public permissions: any[];
  public isInherited: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogAddAlertComponent>,
    private dialog: MatDialog,
    private api: APIHelper,
    private alertService: AlertService,
    private notificationService: AlertsNotificationsService,
    protected userService: UserService
  ) {
  }

  ngOnInit() {
    this.loading = false;
    this.file = this.data.file;
    this.selectedId = this.data.file.id;

    this.name = new FormControl(this.file.name);
    this.description = '';
    this.inheritedPermissions = [];
    this.permissions = [];
    this.listuser = [];
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogSelectUserComponent, {
      width: '70%',
      height: '55%',
      data: {
        isClient: this.userService.user.isClient,
        organisation: this.userService.user.company.organization
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.users = result;
      for (const user of result) {
        if (user.properties['cm:authorityName'] != null) {
          this.userids.push(user.properties['cm:authorityName']);
        } else {
          this.userids.push(user.properties['cm:owner'].id);
        }
      }
      this.listuser.push(this.users);
      if (!result || !result.length) {
        return;
      }
    });
  }

  async onValidate() {
    this.loading = true;
    const data: any = {
      nodeRef: 'workspace://SpacesStore/' + this.file.id,
      description: this.description,
      'expireDate-iso': this.date.toISOString(),
      authorities: this.userids.join()
    };
    const authorities: NotificationAuthority[] = [];
    this.userids.forEach(uid => {
      authorities.push({
        type: NotificationAuthorityType.Single,
        value: uid
      });
    });
    const notificationData: Notification = {
      domain: 'alert',
      content: {
        fileName: this.file.name,
        nodeRef: 'workspace://SpacesStore/' + this.file.id,
        description: this.description,
        expireDateIso: this.date,
        authorities: this.userids.join()
      },
      authorities: authorities,
      metadata: {
        creator: this.userService.user.id
      }
    };

    this.alertService.createAlert(data).then(val => {
      this.notificationService.notifyCreated(notificationData);
    });
    this.dialogRef.close(true);
  }

  changeHerit(value) {
    const data = {permissions: {isInheritanceEnabled: value.checked}};
  }

  removePermission(user: any) {
    this.userids.splice(this.userids.indexOf(user), 1);
  }

  public hasAlreadyBeenAdded(el, arr) {
    let i = 0;
    for (const r of arr) {
      if (r.authorityId === el.authorityId) {
        return i;
      }

      i++;
    }

    return -1;
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
